import { SEGMENTS } from "@/lib/segments";
import { Sparkles, Search, Loader2 } from "lucide-react";

const EXAMPLES = {
  mulheres: ["morena brasileira em Lisboa que atende casais", "loira portuguesa até 25 anos no Porto", "acompanhante que fala inglês e espanhol"],
  trans: ["trans brasileira em Lisboa", "trans loira no Porto com local próprio"],
  homens: ["acompanhante masculino no Porto", "boy discreto em Lisboa"],
  massagens: ["massagem tântrica no Algarve", "massagista brasileira em Lisboa com local"],
};

// Category selector + natural-language query box + examples. All search actions
// are delegated to the parent via onSearch (called with no arg for the button,
// or with an example string for the quick chips).
export default function AISearchForm({ category, setCategory, query, setQuery, loading, onSearch }) {
  return (
    <div className="bg-[#18181b] border border-[#27272a] p-6">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-[#c8aa6e]" strokeWidth={1.5} />
        <h3 className="font-head text-lg text-[#fafafa]">Pesquisa Inteligente</h3>
      </div>
      <p className="text-sm text-[#a1a1aa] mb-4">
        1) Escolha a categoria. 2) Descreva por palavras o que procura. A IA analisa as descrições dos perfis dessa categoria e devolve um ranking de relevância.
      </p>
      <div className="label-tiny mb-2">Categoria <span className="text-[#ef4444]">*</span></div>
      <div className="flex border border-[#27272a] w-fit mb-4" data-testid="ai-category">
        {SEGMENTS.map((c) => (
          <button key={c.k} type="button" data-testid={`ai-cat-${c.k}`} onClick={() => setCategory(c.k)}
            className={`px-4 py-2 text-xs transition-colors ${category === c.k ? "bg-[#c8aa6e] text-black" : "text-[#a1a1aa] hover:text-[#fafafa]"}`}>
            {c.label}
          </button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <textarea data-testid="ai-query" value={query} onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) onSearch(); }} rows={2}
          placeholder={category ? "Ex: morena brasileira em Lisboa, simpática, que atende casais…" : "Selecione primeiro a categoria acima"}
          className="flex-1 bg-[#09090b] border border-[#3f3f46] text-[#fafafa] placeholder-[#71717a] focus:border-[#c8aa6e] outline-none px-3 py-2.5 text-sm resize-none disabled:opacity-60"
          disabled={!category} />
        <button data-testid="ai-search-btn" onClick={() => onSearch()} disabled={loading || !category}
          className="bg-[#c8aa6e] text-black hover:bg-[#d4b982] active:scale-[0.98] px-5 py-2.5 font-medium text-sm transition-all flex items-center justify-center gap-2 disabled:opacity-60 sm:w-44">
          {loading ? <Loader2 className="w-4 h-4 spin" /> : <Search className="w-4 h-4" />}
          {loading ? "A analisar…" : "Pesquisar"}
        </button>
      </div>
      {!category && <p className="text-xs text-[#c8aa6e] mt-2" data-testid="ai-category-hint">Selecione uma categoria para poder pesquisar.</p>}
      {category && (
        <div className="flex flex-wrap gap-2 mt-4">
          {EXAMPLES[category].map((ex) => (
            <button key={ex} onClick={() => onSearch(ex)} disabled={loading}
              className="text-xs border border-[#3f3f46] text-[#a1a1aa] hover:border-[#c8aa6e] hover:text-[#c8aa6e] px-3 py-1.5 transition-colors">
              {ex}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
